"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExceptionMap = exports.ConfiguredErrors = void 0;
var result_1 = require("antd/lib/result");
Object.defineProperty(exports, "ExceptionMap", { enumerable: true, get: function () { return result_1.ExceptionMap; } });
exports.ConfiguredErrors = [
    "400",
    "401",
    "403",
    "404",
    "405",
    "406",
    "408",
    "409",
    "500",
    "501",
    "502",
    "503",
    "504",
    "599",
];
//# sourceMappingURL=ResultProps.js.map